import { PropsWithChildren, useEffect } from 'react';

//import components
import { Header } from './Header';
import Sidebar from './Sidebar';

//redux
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  useDisclosure,
} from '@chakra-ui/react';
import { Logo } from '../Logo';
import { menuItems } from './Menu';
import { Collapsable } from '../Collapsable';
import { matchPath } from 'react-router';
import { Link } from 'react-router-dom';
import Icon from '@ailibs/feather-react-ts';
import { isFeatherIcon } from './utils';

const Layout = (props: PropsWithChildren) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id='layout-wrapper'>
      <Header onMenuClick={onOpen} />
      <Sidebar onMenuClick={onOpen} />
      <div className='main-content'>{props.children}</div>

      <Drawer isOpen={isOpen} placement='left' onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader display='flex' justifyContent='center' alignItems='center'>
            <Logo variant='colorful' maxWidth='70px' maxHeight='48px' />
          </DrawerHeader>
          <DrawerBody padding={0}>
            <Flex as='ul' direction='column' p={0} m={0}>
              {menuItems?.map(item => {
                const hasSubItems = !!item?.subItems?.length;
                const isHomePage = location?.pathname === '/';
                let isItemActive = false;

                if (hasSubItems) {
                  const hasSomeActive = item?.subItems
                    ?.map(item => location?.pathname?.includes(item?.link))
                    ?.some(value => value);

                  isItemActive = hasSomeActive;

                  return (
                    <Flex key={item?.label} direction='column'>
                      <Collapsable
                        active={isItemActive}
                        toggler={
                          <Flex px={4} py={4} gap={3} alignItems='center' fontWeight='medium'>
                            {isFeatherIcon(item.icon) ? <Icon name={item.icon} size='24px' /> : item.icon}
                            {item.label}
                          </Flex>
                        }
                        togglerProps={{
                          w: '100%',
                          color: isItemActive ? 'brand.500' : 'text.main',
                          h: 'auto',
                        }}
                        contentWrapperProps={{
                          mt: 0,
                          py: 0,
                        }}
                      >
                        <Flex as='ul' direction='column' p={0} m={0}>
                          {item?.subItems?.map(subitem => {
                            const isSubItemActive = subitem?.link
                              ? !!matchPath({ path: location.pathname }, subitem?.link as string)
                              : false;

                            return (
                              <li key={subitem.label} className='list-unstyled'>
                                <Flex
                                  px={4}
                                  py={4}
                                  as={Link}
                                  to={subitem.link}
                                  onClick={() => {
                                    onClose();
                                    window.scrollTo(0, 0);
                                  }}
                                  gap={3}
                                  alignItems='center'
                                  fontWeight='medium'
                                  color={isSubItemActive ? 'white' : 'text.main'}
                                  backgroundColor={isSubItemActive ? 'brand.500' : ''}
                                  _hover={{
                                    color: isSubItemActive ? 'white' : 'text.main',
                                  }}
                                >
                                  {subitem.label}
                                </Flex>
                              </li>
                            );
                          })}
                        </Flex>
                      </Collapsable>
                    </Flex>
                  );
                }

                if (isHomePage) {
                  isItemActive = item?.link === '/';
                } else {
                  isItemActive = item?.link !== '/' ? location.pathname.includes(item?.link as string) : false;
                }

                return (
                  <li key={item?.label} className='list-unstyled'>
                    <Flex
                      px={4}
                      py={4}
                      as={Link}
                      to={item.link}
                      onClick={() => {
                        onClose();
                        window.scrollTo(0, 0);
                      }}
                      gap={3}
                      alignItems='center'
                      fontWeight='medium'
                      color={isItemActive ? 'white' : 'text.main'}
                      backgroundColor={isItemActive ? 'brand.500' : ''}
                      _hover={{
                        color: isItemActive ? 'white' : 'text.main',
                      }}
                    >
                      {isFeatherIcon(item.icon) ? <Icon name={item.icon} size='24px' /> : item.icon}
                      {item.label}
                    </Flex>
                  </li>
                );
              })}
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </div>
  );
};

export default Layout;
